import {IndicationBasicModel} from './response/indication-basic.model';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {EnvironmentService} from '@core/environment/environment.service';
import {LanguageEnum} from '@core/enums/language.enum';
import {OutlineChapterWithMarkerBasicModel} from '@core/modules/rest/consent/response/outline-chapter-with-marker-basic.model';
import {IndicationUnitsRequestModel} from '@core/modules/rest/consent/request/indication-units-request.model';
import {IndicationSimpleModel} from '@core/modules/rest/indication/response/indication-simple.model';
import {IndicationModel} from '@core/modules/rest/indication/response/indication.model';
import {IndicationBasicStatusCodeModel} from '@core/modules/rest/indication/response/indication-basic-status-code.model';
import {IndicationBasicWithChapterNumberModel} from '@core/modules/rest/indication/response/indication-basic-with-chapter-number.model';
import {OutlineUnitBasicModel} from '@core/modules/rest/consent/response/outline-unit-basic.model';
import {ChangeUnitLevelRequestModel} from '../informationunit/request/change-unit-level-request.model';
import {ChangeUnitOrderModel} from '@core/modules/rest/informationunit/request/change-unit-order.model';
import {ChangeUnitRelevanceRequestModel} from '@core/modules/rest/informationunit/request/change-unit-relevance-request.model';

@Injectable()
export class IndicationRestService {

    private controllerUrl = this.environmentService.serverApiUrl + '/secured/indication';

    constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    }

    getIndication(id: string, language: LanguageEnum): Observable<IndicationBasicModel> {
        return this.httpClient.get<IndicationBasicModel>(this.controllerUrl + `/${id}/${language}`);
    }

    getIndicationDetails(id: string): Observable<IndicationModel> {
        return this.httpClient.get<IndicationModel>(this.controllerUrl + `/${id}`);
    }

    getOrganizationIndications(language: LanguageEnum): Observable<IndicationBasicModel[]> {
        return this.httpClient.get<IndicationBasicModel[]>(this.controllerUrl + `/${language}/organization/all`);
    }

    getIndicationsSimple(language: LanguageEnum): Observable<IndicationSimpleModel[]> {
        return this.httpClient.get<IndicationSimpleModel[]>(this.controllerUrl + `/${language}/simple/all`);
    }

    getAllIndicationUnits(request: IndicationUnitsRequestModel): Observable<OutlineChapterWithMarkerBasicModel> {
        return this.httpClient.post<OutlineChapterWithMarkerBasicModel>(this.controllerUrl.concat('/').concat(request.indicationId).concat('/units'), request);
    }

    getCMSOutlineFlat(request: IndicationUnitsRequestModel): Observable<OutlineUnitBasicModel[]> {
        return this.httpClient.post<OutlineUnitBasicModel[]>(this.controllerUrl.concat('/').concat(request.indicationId).concat('/units-flat'), request);
    }

    cloneIndication(indicationId: string, language: LanguageEnum): Observable<IndicationBasicModel> {
        return this.httpClient.get<IndicationBasicModel>(this.controllerUrl + `/${indicationId}/${language}/clone`);
    }

    getOrganizationIndicationsWithAUnitsNumber(language: LanguageEnum): Observable<IndicationBasicWithChapterNumberModel[]> {
        return this.httpClient.get<IndicationBasicWithChapterNumberModel[]>(this.controllerUrl + `/${language}/organization/all-with-units`);
    }

    saveIndication(newIndication: IndicationModel, language: LanguageEnum): Observable<IndicationBasicStatusCodeModel> {
        return this.httpClient.put<IndicationBasicStatusCodeModel>(this.controllerUrl + `/${language}`, newIndication);
    }

    moveUnitLevelUp(request: ChangeUnitLevelRequestModel): Observable<OutlineUnitBasicModel[]> {
        return this.httpClient.post<OutlineUnitBasicModel[]>(this.controllerUrl.concat('/moveLevelUp'), request);
    }

    moveUnitLevelDown(request: ChangeUnitLevelRequestModel): Observable<OutlineUnitBasicModel[]> {
        return this.httpClient.post<OutlineUnitBasicModel[]>(this.controllerUrl.concat('/moveLevelDown'), request);
    }

    reorderUnits(request: ChangeUnitOrderModel): Observable<OutlineUnitBasicModel[]> {
        return this.httpClient.post<OutlineUnitBasicModel[]>(this.controllerUrl.concat('/reorderUnits'), request);
    }

    changeUnitRelevance(request: ChangeUnitRelevanceRequestModel): Observable<void> {
        return this.httpClient.post<void>(this.controllerUrl.concat('/changeUnitRelevance'), request);
    }
}
